import React from "react";

function formatDate(dateValue, locale) {
  if (!dateValue) return "-";
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return dateValue;
  return date.toLocaleDateString(locale);
}

function formatCurrencyRounded(value, locale) {
  const amount = Math.round(Number(value || 0));
  return `${amount.toLocaleString(locale)} €`;
}

export default function AgencyThankYou({ form, t, locale = "it-IT" }) {
  const indemnity = Number(form.amount || 0) * 0.7;

  return (
    <section className="agency-thankyou">
      <p className="agency-thankyou-title">{t.thankTitle}</p>
      <p>{t.thankIntro}</p>
      <ul className="agency-thankyou-list">
        <li>🗓️ {t.day}: {formatDate(form.start_date, locale)}</li>
        <li>🏰 {t.venue}: {form.location || "-"}</li>
        <li>
          🕦 {t.timeRange}: {form.start_hour || "-"} - {form.end_hour || "-"}
        </li>
        <li>💧 {t.activationThreshold}: {form.amount_rain || "5mm"}</li>
        <li>💰 {t.insuredBudget}: {formatCurrencyRounded(form.amount, locale)}</li>
        <li>💸 {t.automaticIndemnity}: {formatCurrencyRounded(indemnity, locale)} (70%)</li>
      </ul>
      <p>{t.thankNextSteps}</p>
      <p>{t.thankNoAction}</p>
      <p>{t.thankContact}</p>
      <p className="agency-thankyou-question">
        {t.doubtsQuestion}
        <br />
        {t.doubts} <a href="mailto:info@wedly.it">info@wedly.it</a>
      </p>
    </section>
  );
}
